import { render, staticRenderFns } from "./IndexCartsPage.vue?vue&type=template&id=455bf19f&"
import script from "./IndexCartsPage.vue?vue&type=script&lang=js&"
export * from "./IndexCartsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports